<template>
  <div class="cashbox-online-check">
    <div class="cashbox-online-check__body">
      <input-select
        option-title-key="name"
        option-value-key="id"
        title=""
        input-class="cashbox-manual__header__input-cashbox"
        v-bind:options="cashboxList"
        v-bind:value="selectedCashboxId"
        @input="onInputCashbox"
      />
      <template v-if="isLoaded">
        <template v-if="isShiftClosed">
          <div class="cashbox-online-check__block">
            <h2>Нет открытой смены</h2>
            <button
              v-if="canOpenShift"
              class="cashbox-online-check__button-action"
              type="button"
              v-bind:disabled="isAwaitCommandExecuted"
              v-on:click="onOpenShift">
              <template v-if="!isAwaitCommandExecuted">
                Открыть смену
              </template>
              <v-progress-circular
                v-else
                color="primary"
                indeterminate
                model-value="20"
              />
            </button>
          </div>
        </template>
        <template v-if="isShiftFailOpened">
          <h2>При открытии смены произошла ошибка</h2>
          <p>{{ shiftStateProps.message }}</p>
          <button
            class="cashbox-online-check__button-action"
            type="button"
            v-bind:disabled="disabledButtons"
            v-on:click="onForceCloseShift">
            <template v-if="!isAwaitCommandExecuted">
              Закрыть смену
            </template>
            <v-progress-circular
              v-else
              color="primary"
              indeterminate
              model-value="20"
            />
          </button>
        </template>
        <div class="cashbox-online-check__block">
          <template v-if="isShitRemoteOpened">
            <h3>Смена открыта через сторонний интерфейс<br>
              Чтобы продолжить работу закройте смену на кассе, затем откройте ее в МИС повторно</h3>
          </template>
          <template v-if="isShitWaitOpened">Идет открытие смены</template>
          <div>
            <template v-if="shownShift">
              <h2>Смена № {{ shiftProps.number }}</h2>
              <div><b>Начало:</b> {{ shiftProps.startsAt }}</div>
              <div><b>Сумма чеков прихода:</b> {{ shiftProps.income }} тнг</div>
              <div><b>Сумма чеков возврата:</b> {{ shiftProps.incomeRefund }} тнг</div>
            </template>
          </div>
        </div>
        <template v-if="isShiftOpened">
          <button
            class="cashbox-online-check__button-action"
            type="button"
            v-bind:disabled="disabledButtons"
            v-on:click="onCloseShift">
            <template v-if="!isAwaitCommandExecuted">
              Закрыть смену
            </template>
            <v-progress-circular
              v-else
              color="primary"
              indeterminate
              model-value="20"
            />
          </button>
          <div class="cashbox-online-check__report-buttons">
            <button
              class="cashbox-online-check__button-action"
              type="button"
              v-bind:disabled="disabledButtons"
              v-on:click="onOpenFormCashInOut(false)">
              Внесение наличных
            </button>
            <button
              class="cashbox-online-check__button-action"
              type="button"
              v-bind:disabled="disabledButtons"
              v-on:click="onOpenFormCashInOut(true)">
              Изъятие наличных
            </button>
          </div>
          <div class="cashbox-online-check__report-buttons">
            <button
              class="cashbox-online-check__button-action"
              type="button"
              v-bind:disabled="disabledButtons"
              v-on:click="onPrintXReport">
              X-отчет
            </button>
          </div>
        </template>
        <div class="cashbox-online-check__report-buttons">
          <button
            class="cashbox-online-check__button-action download"
            type="button"
            v-bind:disabled="isAwaitCommandExecuted"
            v-on:click="onDownloadApplication">
            Скачать приложение
          </button>
          <button
            type="button"
            v-on:click="shownDownloadExcelReport = !shownDownloadExcelReport"
            class="cashbox-online-check__button-excel"
          >EXCEL</button>
        </div>
        <div v-if="hasOperations" class="cashbox-online-check__operation-table">
          <h3>Операции за день</h3>
          <div class="cashbox-online-check__operation-table__head">
            <div class="cashbox-online-check__operation-table__cell">Дата</div>
            <div class="cashbox-online-check__operation-table__cell">Тип</div>
            <div class="cashbox-online-check__operation-table__cell">Пациент</div>
            <div class="cashbox-online-check__operation-table__cell">Кассир</div>
            <div class="cashbox-online-check__operation-table__cell">Сумма</div>
            <div class="cashbox-online-check__operation-table__cell">Детали</div>
          </div>
          <div class="cashbox-online-check__operation-table__body">
            <div
              class="cashbox-online-check__operation-table__row"
              v-for="(operation, index) in operationListInDay"
              v-bind:key="index"
              v-bind:class="operation.type"
            >
              <div
                data-label="Дата"
                class="cashbox-online-check__operation-table__cell">{{ operation.date_time }}</div>
              <div
                data-label="Тип"
                class="cashbox-online-check__operation-table__cell type">{{ operation.type_title }}</div>
              <div
                data-label="Пациент"
                class="cashbox-online-check__operation-table__cell">{{ operation.patient_name }}</div>
              <div
                data-label="Кассир"
                class="cashbox-online-check__operation-table__cell">{{ operation.cashier_name }}</div>
              <div
                data-label="Сумма"
                class="cashbox-online-check__operation-table__cell amount">{{ operation.amount }}</div>
              <div
                data-label="Детали"
                class="cashbox-online-check__operation-table__cell">{{ operation.details }}</div>
            </div>
          </div>
        </div>
      </template>
      <modal-dialog
        title="Приложение"
        v-model="shownDownloadAppDialog"
        with-cross>
        <b>Код привязки:</b> {{appLink.authCode}}
        <br>
        <a
          v-bind:href="appLink.link"
          download>
          Скачать
        </a>
      </modal-dialog>
      <modal-dialog
        title="Отчет"
        v-model="shownDownloadExcelReport"
        with-cross>
        <date-range-with-presets
          v-bind:presets="periodPresets"
          v-if="periodDates.length"
          v-model="periodDates" />
        <button
          class="cashbox-online-check__button-action download"
          type="button"
          v-on:click="fetchReportSpreadsheet">
          Скачать
        </button>
      </modal-dialog>
      <modal-dialog
        persistent
        v-bind:title="formInOutLabel"
        v-model="shownInOutCashForm">
        <form
          class="cashbox-online-check__modal"
          v-on:submit.prevent="onInOutSubmit"
        >
          <input-number
            name="amount"
            title="Сумма"
            without-native-controls
            v-bind:min="'0'"
            v-bind:required="true"
            v-model="amount"
          />
          <textarea-length-limitation
            class="cashbox-online-check__description"
            rows="3"
            title="Примечание"
            v-bind:max-length="200"
            v-model="note"
            v-letter-capital
            v-bind:optional="false"
          />
          <div class="cashbox-online-check__modal__buttons">
            <button
              class="cashbox-online-check__button-cancel"
              type="button"
              v-bind:disabled="disabledModalButtons"
              v-on:click="shownInOutCashForm = false">Отмена</button>
            <button
              class="cashbox-online-check__button-action"
              type="submit"
              v-bind:disabled="disabledModalButtons">
              {{formInOutSubmitButtonText}}
            </button>
          </div>
        </form>
      </modal-dialog>
    </div>
  </div>
</template>

<script>
import notifierMixin from '@/mixins/notifierMixin';
import onlineCheckMixin, { STATUS_FAIL } from '@/mixins/onlineCheckMixin';
import { List, Maybe } from 'monet';
import InputNumber from '@/components/InputNumber.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';
import DateRangeWithPresets from '@/components/DateRangeWithPresets.vue';
import InputSelect from '@/components/InputSelect.vue';
import { CashInOutRequest } from '@/storage/gateways/CashboxGateway';
import { convertToInputDate } from '../../utils/timeFormat';

/**
 * @description Х-отчет.
 * @type {string}
 */
const XReport = 'x-report';

/**
 * @description Сохранить файл.
 * @param {any}    file Файл.
 * @param {string} name Название файла.
 */
function saveFile(file, name) {
  const obj = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = obj;
  link.target = '_blank';
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
  link.remove();
}

/**
 * @description Касса.
 * @type {any}
 */
export default {
  components: {
    DateRangeWithPresets,
    ModalDialog,
    InputSelect,
    InputNumber,
    TextareaLengthLimitation,
  },
  computed: {
    canOpenShift() {
      return this.actions.includes('open-shift');
    },
    formInOutLabel() {
      return `${this.isOut ? 'Изъятие' : 'Внесение'} наличных`;
    },
    formInOutSubmitButtonText() {
      return this.isOut ? 'Изъять' : 'Внести';
    },
    /**
     * @description Деактивировать кнопки.
     * @type {boolean}
     */
    disabledButtons() {
      return (
        this.shiftProps.isRemoteOpen === true || this.isAwaitCommandExecuted
      );
    },
    disabledModalButtons() {
      return this.isAwaitRequest || this.isAwaitCommandExecuted;
    },
    /**
     * @description Смена получена.
     * @type {boolean}
     */
    isLoaded() {
      return !this.shift.isNone();
    },
    /**
     * @description Смена закрыта.
     * @type {boolean}
     */
    isShiftClosed() {
      return this.shiftStateProps.type === 'closed';
    },
    /**
     * @description При открытии смены произошла ошибка.
     * @type {boolean}
     */
    isShiftFailOpened() {
      return this.shiftStateProps.type === 'fail';
    },
    /**
     * @description Смена открыта.
     * @type {boolean}
     */
    isShiftOpened() {
      return this.shiftStateProps.type === 'opened';
    },
    /**
     * @description Смена открыта через сторонний интерфейс.
     * @type {boolean}
     */
    isShitRemoteOpened() {
      return this.shiftStateProps.type === 'remote-opened';
    },
    /**
     * @description Смена в процессе открытия.
     * @type {boolean}
     */
    isShitWaitOpened() {
      return this.shiftStateProps.type === 'wait';
    },
    /**
     * @description Данные смены.
     * @type {any}
     */
    shiftProps() {
      return this.shift.fold({})((shift) => shift);
    },
    /**
     * @description Состояние смены.
     * @type {any}
     */
    shiftStateProps() {
      return this.shiftState.fold({})((state) => ({
        commandId: state.command_id,
        message: state.message,
        shiftId: state.shift_id,
        type: state.type,
      }));
    },
    shownShift() {
      return this.isShiftOpened;
    },
    isAwaitOpeningShift() {
      if (
        this.shiftStateProps.commandId === 0
        || this.shiftProps.isOpen === false
      ) {
        return false;
      }
      return this.shiftStateProps.isReceived === false;
    },
    hasOperations() {
      return this.operationListInDay.size() > 0;
    },
    appLink() {
      return this.downloadAppLink.fold({})((props) => props);
    },
    /**
     * @description Предварительные установки периодов.
     * @returns {({toValue: function(): [Date,Date], id: string, label: string, title: string}[])}
     */
    periodPresets() {
      return this.periodTypes.map(({ fromTo: [from, to], title, value }) => ({
        id: value,
        label: title,
        title,
        toValue: () => [new Date(from), new Date(to)],
      }));
    },
    noteInputErrors() {
      return 'note' in this.cashInOutInputErrors ? this.cashInOutInputErrors.note : [];
    },
  },
  created() {
    this.fetchShift();
    this.fetchOptions().then(() => {
      this
        .periodPresets
        .slice(0, 1)
        .map(({ toValue }) => toValue())
        .forEach((value) => {
          this.periodDates = value;
        });
    });
  },
  data() {
    return {
      actions: [],
      /**
       * @description Смена.
       * @type {Maybe}
       */
      shift: Maybe.none(),
      isOut: false,
      shownInOutCashForm: false,
      amount: 0,
      note: '',
      isAwaitRequest: false,
      operationListInDay: List(),
      /**
       * @description Состояние смены.
       * @type {Maybe}
       */
      shiftState: Maybe.none(),
      shownDownloadAppDialog: false,
      shownDownloadExcelReport: false,
      downloadAppLink: Maybe.none(),
      /**
       * @description Выбранные период дней.
       * @type {([Date, Date])}
       */
      periodDates: [],
      cashInOutInputErrors: {},
    };
  },
  methods: {
    /**
     * @description Закрыть смену.
     * @returns {void}
     */
    closeShift() {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        if (result.command_id) {
          this.onWaitShiftClosed(result.command_id);
        } else {
          this.notifySuccess(result.message);
          this.fetchShift();
        }
      };
      this.$cashboxGateway
        .closeShift(this.shiftStateProps.shiftId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Закрыть внешнюю смену.
     * @returns {void}
     */
    closeExternalShift() {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        if (result.command_id) {
          this.onWaitShiftClosed(result.command_id);
        } else {
          this.notifySuccess(result.message);
          this.fetchShift();
        }
      };
      this.$cashboxGateway
        .closeExternalShift()
        .then((result) => result.fold(onFail, onSuccess));
    },
    onDownloadApplication() {
      const onSuccess = (response) => {
        this.downloadAppLink = Maybe.some({
          link: response.link,
          authCode: response.auth_code,
        });
        this.shownDownloadAppDialog = true;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this.isAwaitRequest = true;
      this
        .$cashboxGateway
        .downloadOnlineCheckApp()
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать отправку формы внесения\изъятия наличных.
     * @returns {void}
     */
    onInOutSubmit() {
      this.cashInOutInputErrors = {};
      if (this.note.length === 0) {
        this.cashInOutInputErrors.note = ['Поле Примечание не может быть пустым'];
        return;
      }
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.cashInOutInputErrors = error.allCauses();
      };
      const onSuccess = (result) => {
        this.waitExecuted(result.command_id)
          .then((commandResult) => {
            if (commandResult.status === STATUS_FAIL) {
              this.notifyFail(commandResult.message);
            } else {
              this.notifySuccess(commandResult.message);
              this.shownInOutCashForm = false;
            }
          }, onFail)
          .finally(() => {
            this.isAwaitCommandExecuted = false;
          });
      };
      this.isAwaitRequest = true;
      const command = this.isOut ? 'out' : 'in';
      const amountToKop = this.amount * 100;
      const request = new CashInOutRequest(
        this.selectedCashboxId,
        command,
        amountToKop,
        this.note,
      );
      this.$cashboxGateway
        .cashInOut(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать открытие формы внесения\изъятия денег.
     * @param {boolean} isOut Изъятие.
     * @returns {void}
     */
    onOpenFormCashInOut(isOut) {
      this.amount = 0;
      this.note = '';
      this.isOut = isOut;
      this.shownInOutCashForm = true;
    },
    /**
     * @description Получить смену.
     * @returns {void}
     */
    fetchShift() {
      const onSuccess = (response) => {
        this.actions = response.actions;
        this.shift = Maybe.some(
          {
            income: response.state.income,
            incomeRefund: response.state.income_refund,
            number: response.state.num,
            startsAt: response.state.starts_at,
          },
        );
        this.shiftState = Maybe.some(response.state);
        this.operationListInDay = List.fromArray(response.operations);
        if (this.isShitWaitOpened) {
          this.onWaitShiftOpening(this.shiftStateProps.commandId);
        }
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this.shift = Maybe.none();
      this.$cashboxGateway
        .viewShift()
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать закрытие смены.
     * @returns {void}
     */
    onCloseShift() {
      if (this.actions.includes('close-external-shift')) {
        this.closeExternalShift();
      } else {
        this.closeShift();
      }
    },
    onWaitShiftClosed(commandId) {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this.waitExecuted(commandId)
        .then((commandResult) => {
          if (commandResult.status === STATUS_FAIL) {
            this.notifyFail(commandResult.message);
            this.fetchShift();
          } else {
            this.notifySuccess('Смена закрыта');
            this.fetchShift();
          }
        }, onFail)
        .finally(() => {
          this.isAwaitCommandExecuted = false;
        });
    },
    /**
     * @description Обработать принудительное закрытие смены.
     * @returns {void}
     */
    onForceCloseShift() {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        this.onWaitShiftClosed(result.command_id);
      };
      this.$cashboxGateway
        .forceCloseShift(this.shiftStateProps.commandId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать открытие смены.
     * @returns {void}
     */
    onOpenShift() {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => this.onWaitShiftOpening(result.command_id);
      this.$cashboxGateway
        .openShift()
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать ожидание открытия смены.
     * @param {number} commandId Идентификатор смены.
     * @returns {void}
     */
    onWaitShiftOpening(commandId) {
      const onSuccess = (result) => {
        if (result.status === STATUS_FAIL) {
          this.notifyFail(result.message);
        }
        this.fetchShift();
      };
      const onFail = (error) => error.forEachFail(onFail);
      this.waitExecuted(commandId)
        .then(onSuccess, onFail)
        .finally(() => {
          this.isAwaitCommandExecuted = false;
        });
    },
    /**
     * @description Обработать печать Х-отчета.
     * @returns {void}
     */
    onPrintXReport() {
      this.printReport(XReport);
    },
    printReport(reportType) {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        this.notifySuccess(result.message);
        if (result.command_id) {
          this.waitExecuted(result.command_id)
            .then((commandResult) => {
              if (commandResult.status === STATUS_FAIL) {
                this.notifyFail(commandResult.message);
              } else {
                this.notifySuccess(commandResult.message);
              }
            }, onFail)
            .finally(() => {
              this.isAwaitCommandExecuted = false;
            });
        } else {
          this.notifySuccess(result.message);
          this.fetchShift();
        }
      };
      this.$cashboxGateway
        .printReport(reportType)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить операции всех счетов пациентов за период в виде таблицы.
     * @returns {void}
     */
    fetchReportSpreadsheet() {
      const onSuccess = (response) => {
        saveFile(response, 'Отчет по кассе.xls');
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const cashboxId = this.selectedCashboxId;
      const dates = this.periodDates.map(convertToInputDate);
      this
        .$cashboxGateway
        .viewOperationsAllPatientInvoicesForPeriodBySheet(cashboxId, ...dates)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить опции.
     * @returns {Promise<void>}
     */
    fetchOptions() {
      return this
        .$cashboxGateway
        .viewInvoiceOperationOptions()
        .then((result) => {
          result.forEach(({ periodTypes }) => {
            this.periodTypes = periodTypes;
          });
        });
    },
    onInputCashbox(cashboxId) {
      this.$emit('input-cashbox', cashboxId);
    },
  },
  name: 'ClinicPanelCashboxOnlineCheck',
  mixins: [notifierMixin, onlineCheckMixin],
  props: {
    cashboxList: { required: true, type: Array },
    selectedCashboxId: { required: true, type: Number },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.cashbox-online-check {
  width: 100%;
  display: flex;
  flex-direction: column;
  &__body {
    padding: 38px 20px 48px 23px;
    width: 100%;
    overflow-y: scroll;
  }
  &__block {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0 0 20px 0;
  }
  &__description {
    margin-top: 5px;
    ::v-deep .textarea-length-limitation__textarea {
      min-height: 80px;
      &:focus-visible {
        background-color: var(--primary-background-color);
        border: 2px solid var(--action-color);
        color: var(--reading-color);
        outline: 0;
      }
    }
  }
  &__report-buttons {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 250px 250px;
    column-gap: 9px;
  }
  &__button {
    &-action {
      @include buttons.btn-blue(100%, 46px, 1rem);
      flex-shrink: 0;
      max-width: 250px;
      &:disabled {
        background-color: var(--unfocus-color);
      }
      &.download {
        margin-top: 20px;
      }
    }
    &-cancel {
      @include buttons.btn-transparent(100%, 46px, 1rem);
      max-width: 250px;
    }
    &-excel {
      @include buttons.btn-transparent(100%, 46px, 1rem);
      max-width: 250px;
      margin-top: 20px;
      &:before {
        content: "";
        background-image: url("@/assets/img/exel.svg");
        background-repeat: no-repeat;
        background-size: contain;
        width: 16px;
        height: 16px;
        margin: 0 8px 0 0;
      }
    }
  }
  &__modal {
    display: flex;
    flex-direction: column;
    gap: 10px;
    &__buttons {
      max-width: 300px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 9px;
    }
    &__input {
      width: 200px;
    }
  }
  &__operation-table {
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    &__body {
      width: 100%;
    }
    &__head,
    &__row {
      display: grid;
      grid-template-columns: 150px 250px 250px 200px 150px 1fr;
    }
    &__row {
      text-align: left;
      border-bottom: 1px solid #eaeff3;
      cursor: default;
      &:nth-child(odd) {
        background-color: var(--fill-color);
      }
      &.out {
        .cashbox-online-check__operation-table__cell.amount,
        .cashbox-online-check__operation-table__cell.type {
          color: #e00404b0;
        }
      }
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
    }
    &__cell {
      transition: color var(--animate-duration);
      padding: 12px 8px;
      display: flex;
      align-items: center;
    }
  }
}
@media screen and (max-width: 1000px) {
  .cashbox-online-check__operation-table {
    &__head,
    &__row {
      grid-template-columns: 100px 150px 150px 180px 100px 1fr;
    }
  }
}
@media screen and (max-width: 700px) {
  .cashbox-online-check__operation-table {
    &__head {
      display: none;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 10px;
      margin: 0 0 20px 0;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 0;
      &.fio {
        text-align: right;
      }
    }
    &__cell:before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
      font-size: 10px;
    }
  }
}
@media screen and (max-width: 550px) {
  .cashbox-online-check {
    &__button-action {
      max-width: 100%;
    }
    &__report-buttons {
      grid-template-columns: 1fr;
      row-gap: 20px;
    }
  }
}
</style>
